export default __webpack_public_path__ + "static/bigdata-937d10baf919d2cb55ede2c5e652828a.svg";